<script setup lang="ts">
import { computed } from 'vue'
import { useHead } from '@unhead/vue'
import type { Resolved } from '@/types'
import { settings, PATHS } from '@/content'
import { useContentHtml } from '@/lib/pageHtml'
import { baseHead } from '@/lib/seo'
import BreadcrumbBar from '@/components/BreadcrumbBar.vue'

const props = defineProps<{ resolved: Resolved }>()
const service = computed(() => props.resolved.service)
const contentHtml = useContentHtml(service.value?.path || PATHS.mentions)
const hasContent = computed(() => !!contentHtml.value)

const crumbs = [
  { label: 'Accueil', path: '/' },
  { label: 'Mentions légales', path: PATHS.mentions },
]

useHead(() => ({
  ...baseHead({
    title: service.value?.seo?.seo_title || 'Mentions légales - Les Ateliers du Terras',
    description:
      service.value?.seo?.seo_description ||
      'Mentions légales du site des Ateliers du Terras : éditeur, hébergement et propriété intellectuelle.',
    canonical: PATHS.mentions,
    index: false,
  }),
}))
</script>

<template>
  <div class="ml">
    <section class="ml-hero">
      <div class="container"><h1>Mentions légales</h1></div>
    </section>
    <BreadcrumbBar :crumbs="crumbs" />
    <section class="section">
      <div class="container">
        <div v-if="hasContent" class="prose" v-html="contentHtml"></div>
        <div v-else class="prose">
          <h2>Éditeur du site</h2>
          <p>
            {{ settings.site_name }}, entreprise artisanale de menuiserie, agencement, couverture et
            isolation.<br />
            {{ settings.agencies[0].street }}, {{ settings.agencies[0].zip }}
            {{ settings.agencies[0].town }}.<br />
            Téléphone : {{ settings.agencies[0].phone_display }} - Email : {{ settings.email }}.
          </p>
          <h2>Hébergement</h2>
          <p>
            Site hébergé sur une infrastructure dédiée. Pour toute question relative au site, merci
            de nous contacter à l'adresse {{ settings.email }}.
          </p>
          <h2>Propriété intellectuelle</h2>
          <p>
            L'ensemble des contenus (textes, photographies, logos) présents sur ce site est la
            propriété des Ateliers du Terras, sauf mention contraire. Toute reproduction sans
            autorisation est interdite.
          </p>
          <h2>Conception et technique</h2>
          <p>Conception et réalisation technique : juliengauthier.org.</p>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.ml-hero {
  background: var(--bg-alt);
  border-bottom: 1px solid var(--border);
  padding: 40px 0;
}
</style>
